export const MAX_TREE_DEPTH = 30;
export const MAX_UPLOAD_SIZE_ATTACHEMENT_LOGGED_IN = 10485760;
export const MAX_UPLOAD_SIZE_ATTACHEMENT_ANONYMOUS = 2097152;
